export default function SmartSystems() {
  const systems = [
    {
      title: 'Climate Control',
      features: ['Smart HVAC system', 'Temperature zones', 'Humidity control', 'Air purification'],
      icon: 'ri-temp-cold-line'
    },
    {
      title: 'Lighting System',
      features: ['Automated day/night modes', 'Mood lighting scenes', 'Energy-efficient LEDs', 'Voice control'],
      icon: 'ri-lightbulb-line'
    },
    {
      title: 'Entertainment',
      features: ['Smart TV integration', 'Premium sound system', 'Streaming services', 'Bluetooth connectivity'],
      icon: 'ri-tv-line'
    },
    {
      title: 'Security',
      features: ['Smart locks', 'Security cameras', 'Motion sensors', 'Remote monitoring'],
      icon: 'ri-lock-line'
    }
  ];

  return (
    <section className="relative py-24 lg:py-32 bg-gradient-to-b from-transparent via-cyan-500/5 to-transparent w-full">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        {/* Section Header */}
        <div className="text-center mb-16 lg:mb-20">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-thin mb-6">
            Smart <span className="text-cyan-400">Technology</span>
          </h2>
          <p className="text-lg sm:text-xl text-gray-400 max-w-3xl mx-auto">
            Integrated intelligent systems for seamless living and hospitality management
          </p>
        </div>

        {/* Systems Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {systems.map((system, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-gray-900/80 to-gray-800/50 border border-cyan-500/30 rounded-3xl p-8 lg:p-10"
            >
              {/* Icon & Title */}
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 bg-cyan-500/10 rounded-2xl flex items-center justify-center flex-shrink-0">
                  <i className={`${system.icon} text-4xl text-cyan-400`}></i>
                </div>
                <h3 className="text-2xl font-medium text-white">{system.title}</h3>
              </div>

              {/* Features List */}
              <ul className="space-y-3">
                {system.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <div className="w-1.5 h-1.5 bg-cyan-400 rounded-full mt-2 flex-shrink-0"></div>
                    <span className="text-gray-300">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Control App Preview */}
        <div className="mt-16 bg-gradient-to-br from-cyan-500/10 to-transparent border border-cyan-500/30 rounded-3xl p-8 lg:p-12 text-center">
          <div className="w-20 h-20 bg-cyan-500/20 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <i className="ri-smartphone-line text-5xl text-cyan-400"></i>
          </div>
          <h3 className="text-2xl font-medium mb-4">Mobile App Control</h3>
          <p className="text-gray-400 max-w-2xl mx-auto">
            Control all systems from your smartphone. Guests can customise their experience, while property managers can monitor and manage multiple units remotely.
          </p>
        </div>
      </div>
    </section>
  );
}